import { DollarSign, Smartphone } from 'lucide-react';

export const PaymentSection = () => {
  return (
    <section data-testid="payment-section" className="py-20 bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="font-['Barlow_Condensed'] text-3xl md:text-4xl font-bold uppercase text-white mb-4">
            Easy Payment Options
          </h2>
          <p className="text-slate-400 max-w-2xl mx-auto">
            We make it convenient for you to pay. Choose from our secure payment methods.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-2xl mx-auto">
          {/* Zelle Payment Card */}
          <a
            href="mailto:kary1907@live.com?subject=Payment%20via%20Zelle"
            data-testid="zelle-payment-card"
            className="group bg-slate-800 border border-slate-700 hover:border-amber-500 rounded-xl p-6 transition-all duration-300 hover:transform hover:-translate-y-1 hover:shadow-xl hover:shadow-amber-500/10"
          >
            <div className="flex items-center gap-4 mb-4">
              <div className="w-12 h-12 bg-purple-600 rounded-lg flex items-center justify-center">
                <DollarSign className="w-6 h-6 text-white" />
              </div>
              <div>
                <h3 className="text-white font-bold text-lg">Zelle</h3>
                <p className="text-slate-400 text-sm">Fast & Secure</p>
              </div>
            </div>
            <div className="bg-slate-900 rounded-lg px-4 py-3">
              <p className="text-slate-400 text-xs mb-1">Send payment to:</p>
              <p className="text-amber-500 font-semibold group-hover:text-amber-400 transition-colors">
                kary1907@live.com
              </p>
            </div>
          </a>

          {/* Cash App Payment Card */}
          <a
            href="https://cash.app/$Electrician100"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="cashapp-payment-card"
            className="group bg-slate-800 border border-slate-700 hover:border-amber-500 rounded-xl p-6 transition-all duration-300 hover:transform hover:-translate-y-1 hover:shadow-xl hover:shadow-amber-500/10"
          >
            <div className="flex items-center gap-4 mb-4">
              <div className="w-12 h-12 bg-green-500 rounded-lg flex items-center justify-center">
                <Smartphone className="w-6 h-6 text-white" />
              </div>
              <div>
                <h3 className="text-white font-bold text-lg">Cash App</h3>
                <p className="text-slate-400 text-sm">Quick Transfer</p>
              </div>
            </div>
            <div className="bg-slate-900 rounded-lg px-4 py-3">
              <p className="text-slate-400 text-xs mb-1">Send payment to:</p>
              <p className="text-amber-500 font-semibold group-hover:text-amber-400 transition-colors">
                $Electrician100
              </p>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
};
